export default {
    filters: {
        numFilter(value) {
            let realVal = ''
            if (!isNaN(value) && value !== '') {
                // 截取当前数据到小数点后两位
                realVal = parseFloat(value).toFixed(2)
            } else {
                realVal = '--'
            }
            return realVal
        }
    }
}